import React from 'react';
import PropTypes from 'prop-types';

const WarningIcon = ({ fill, style, ...rest }) => (
  <svg
    {...rest}
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 45 38"
    style={{ enableBackground: 'new 0 0 26.095 21.739', ...style }}
  >
    <g id="Group_90" transform="translate(-936.144 -361.734)">
      <path
        id="Path_1191"
        fill={fill}
        d="M980.6,393.7l-18.4-30.1c-1.2-1.9-3.7-2.5-5.6-1.3c-0.5,0.3-1,0.8-1.3,1.3l-18.4,30.1 c-0.8,1.2-0.8,2.8-0.1,4c0.7,1.2,2.1,2,3.5,2h36.9c1.4,0,2.8-0.8,3.5-2C981.3,396.5,981.3,394.9,980.6,393.7z M978.1,396.3 c-0.2,0.3-0.6,0.6-1,0.6h-36.9c-0.4,0-0.8-0.2-1-0.6c-0.2-0.3-0.2-0.8,0-1.1l18.5-30.1c0.2-0.3,0.6-0.5,0.9-0.5 c0.4,0,0.7,0.2,1,0.5l18.4,30.1C978.3,395.5,978.3,396,978.1,396.3L978.1,396.3z"
      />
      <path
        id="Path_1192"
        fill={fill}
        d="M958.7,373.4c-1.1,0-2,0.6-2,1.7c0,3.2,0.4,7.9,0.4,11.2c0,0.9,0.8,1.2,1.6,1.2 c0.7,0,1.6-0.4,1.6-1.2c0-3.2,0.4-7.9,0.4-11.2c-0.1-1-0.9-1.7-1.9-1.7C958.7,373.4,958.7,373.4,958.7,373.4z"
      />
      <path
        id="Path_1193"
        fill={fill}
        d="M958.6,389.1c-1.2,0-2.1,0.9-2.1,2.1s0.9,2.1,2.1,2.1c0,0,0,0,0,0c1.2,0,2.1-0.9,2.1-2.1 S959.8,389.1,958.6,389.1C958.7,389.1,958.7,389.1,958.6,389.1z"
      />
    </g>
  </svg>
);

WarningIcon.propTypes = {
  fill: PropTypes.string,
  style: PropTypes.object,
  rest: PropTypes.object,
};

WarningIcon.defaultProps = {
  fill: '#FFFFFF',
  style: {},
  rest: {},
};

export default WarningIcon;



// WEBPACK FOOTER //
// ./src/assets/WarningIcon.jsx